import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { ReportInfo } from '../../../Models/Models/Reports/ReportInfo';
import { IJsonDate } from '../../../System/IJsonDate';

declare var IS_RUNNING_IN_APP_POOL;

export class ContributionsReportClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(subAccountHierarchyId: string, fromDate: IJsonDate, fromInception: boolean): Promise<ReportInfo, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Reports/Contributions/ContributionsReport/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { subAccountHierarchyId: subAccountHierarchyId, fromDate: fromDate, fromInception: fromInception }

    return AjaxWrapper.post<ReportInfo, any>(url, data);
  }
}

